import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./CreateTask.css";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { capitalize } from "lodash";
import MessageBox from "../MessageBox/MessageBox";
import { sendNotification } from "../../utils/notification"; // Adjust the import path as necessary

export default function CreateTask() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [names, setNames] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageData, setMessageData] = useState(null);

  const Id = useSelector((state) => state.id);
  const [searchText, setSearchText] = useState("");

  let [taskAssignDate, setTaskAssignDate] = useState("");

  let [taskDeadline, setTaskDeadline] = useState("");
  const staffName = useSelector((state) => state.staffname);

  const [searchTerm, setSearchTerm] = useState("");

  const filteredNames = names.filter((staff) =>
    staff.staffName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
  const [approvePerson, setApprovePerson] = useState(null); // initially no one selected
  const [approvePersons, setApprovePersons] = useState([]); // Array of selected persons
  const [isApproveOpen, setIsApproveOpen] = useState(false);
  const approveDropdownRef = useRef(null);

  const [selectedNames, setSelectedNames] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [taskData, setTaskData] = useState({
    taskName: "",
    assignDateTime: "",
    // taskType: 'Once',
    taskPriority: "Low",
    deadline: "",
    time: "",
    assignedTo: [], // Array for multiple selections
    approvePerson: "",
    description: "",
    name: "",
    leadId: "",
    taskStatus: "Open",
    assignedBy: "",
    approveStatus: "Pending",
  });



  const formatDateTimeLocal = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};



useEffect(() => {
  if (taskData.assignDateTime) {
    const assignDate = new Date(taskData.assignDateTime);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
    const formattedDeadline = formatDateTimeLocal(deadlineDate);

    setTaskData(prev => ({
      ...prev,
      deadline: formattedDeadline
    }));
  }
}, [taskData.assignDateTime]);





const handleInputChange = (field, value) => {
  if (field === 'assignDateTime') {
    const assignDate = new Date(value);
    const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000);
    
    // Use the same helper function to keep it in local time
    const formattedDeadline = formatDateTimeLocal(deadlineDate);

    setTaskData(prev => ({
      ...prev,
      assignDateTime: value,
      deadline: formattedDeadline // auto update
    }));
  } else {
    setTaskData(prev => ({
      ...prev,
      [field]: value
    }));
  }
};



  useEffect(() => {
    axios
      .get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          setNames(res.data.message); // names = array of objects like { _id, staffName }
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fetch staff all data
  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setStaffData(res.data.message);

        console.log(res.data.message);
      });
  }, [apiUrl]);

  // Toggle dropdown open/close
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  // Checkbox change handler expects a staffName string
  const handleCheckboxChange = (staff) => {
    setSelectedNames((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };
    const handleApproveCheckboxChange = (staff) => {
    setApprovePersons((prev) => {
      const exists = prev.find((item) => item._id === staff._id);
      if (exists) {
        // remove staff
        return prev.filter((item) => item._id !== staff._id);
      } else {
        // add staff
        return [...prev, staff];
      }
    });
  };

  // Display text: show staff names of selected IDs
  const displayText =
    selectedNames.length > 0
      ? selectedNames.map((item) => item.staffName).join(", ")
      : "Select names";

  const assignedTo = selectedNames; // [{_id, staffName}, {_id, staffName}, ...]

  const approvePersonDisplay = approvePerson
    ? approvePerson.staffName
    : "Select Approve Person";

  // Display selected staff names joined by comma, or default text

  const handleApprovePersonChange = (staff) => {
    setApprovePerson(staff); // just set the selected staff object
  };

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;

    setTaskData((prev) => ({
      ...prev,
      assignDateTime: formattedDate,
    }));
  }, []);

  const navi = useNavigate();

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  function gototaskPage() {
    navi("/task");
  }

  const [IsOpenTask, setIsOpenTask] = useState(false);
  const [IsUpdateHistory, setIsUpdateHistory] = useState(false);
  const [isOpenConverted, setIsOpenConverted] = useState(false);
  const [IsDotBox, setIsDotBox] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditable, setIsEditable] = useState(true);

  function showOpenTask() {
    setIsOpenTask(true);
  }
  const toggleApproveDropdown = () => {
    setIsApproveOpen((prev) => !prev);
  };

  // const handleApproveCheckboxChange = (staff) => {
  //   setApprovePersons(prev => {
  //     const exists = prev.find(item => item._id === staff._id);
  //     if (exists) {
  //       // Remove staff
  //       return prev.filter(item => item._id !== staff._id);
  //     } else {
  //       // Add staff
  //       return [...prev, staff];
  //     }
  //   });
  // };
  // Handle approver selection

  
  const approvePersonText =
    approvePersons.length > 0
      ? approvePersons.map((item) => item.staffName).join(", ")
      : "Select Approve Persons";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        approveDropdownRef.current &&
        !approveDropdownRef.current.contains(event.target)
      ) {
        setIsApproveOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [isEditMode, setIsEditMode] = useState(false);

  //  const handleSubmitAssignTask = async (e) => {
  //   e.preventDefault();

  //   // Change confirmation text based on edit mode
  //   const result = await Swal.fire({
  //     title: isEditMode ? "Update the changes?" : "Are you sure you want to create this task?",
  //     showCancelButton: true,
  //     confirmButtonText: isEditMode ? "Update" : "Submit",
  //   });

  //   if (!result.isConfirmed) return;

  //   try {
  //     const now = new Date();
  //     const day = String(now.getDate()).padStart(2, "0");
  //     const month = String(now.getMonth() + 1).padStart(2, "0");
  //     const year = now.getFullYear();
  //     const updatedDate = `${day}-${month}-${year}`;
  //     let hours = now.getHours();
  //     const minutes = String(now.getMinutes()).padStart(2, "0");
  //     const ampm = hours >= 12 ? "PM" : "AM";
  //     hours = hours % 12 || 12;
  //     const updatedTime = `${hours}:${minutes} ${ampm}`;

  //     const taskPayload = {
  //       ...taskData,
  //       assignedBy: { staffName, id: Id },
  //       updatedDate,
  //       updatedTime,
  //       assignedTo: selectedNames,
  //       approvePerson: approvePersons,
  //     };

  //     // Required validation
  //     const requiredFields = ["taskName", "assignDateTime", "deadline", "assignedTo", "approvePerson", "description"];
  //     const emptyFields = requiredFields.filter(
  //       (field) => !taskPayload[field] || (Array.isArray(taskPayload[field]) && taskPayload[field].length === 0)
  //     );

  //     if (emptyFields.length > 0) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Incomplete Data",
  //         text: `Please fill all the fields.`,
  //       });
  //       return;
  //     }

  //     if (isEditMode) {
  //       // Update logic
  //       await axios.post(apiUrl + "update-assign-task", taskPayload, {
  //         headers: { "Content-Type": "application/json" },
  //       });
  //       savedId = taskPayload._id;
  //     } else {
  //       // Create logic
  //       const response = await axios.post(apiUrl + "add-assign-task", taskPayload, {
  //         headers: { "Content-Type": "application/json" },
  //       });
  //       savedId = response.data?.data?._id;
  //       //setTaskId(savedId); // Optional: store for further use
  //     }

  //     // === Add Message (history) ===
  //     const formData = new FormData();
  //     formData.append("pageRefId", savedId);
  //     formData.append("page", "Task");
  //     formData.append("colorCode", "#fbdc6e");
  //     formData.append("description", taskData.description);
  //     formData.append("staffPic", "");
  //     if (selectedFile) {
  //       formData.append("image", selectedFile);
  //     }
  //     formData.append("updatesHistory[staff][name]", staffName);
  //     formData.append("updatesHistory[staff][id]", Id);
  //     formData.append("updatesHistory[status]", "Open");

  //     await axios.post(apiUrl + "add-message", formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });

  //     // ✅ Fetch messages after update
  //     const msgRes = await axios.get(`${apiUrl}messages/${savedId}`);
  //     setMessageData(msgRes.data.data);
  //     setShowMessageBox(true);

  //     Swal.fire("Success!", isEditMode ? "Task Updated" : "Task Created", "success");
  //     setIsEditable(false);
  //     setIsEditMode(false);
  //     setIsSubmitted(true);
  //     // navigate("/task")
  //   }

  //    catch (error) {
  //     console.error("Submit error:", error);
  //     Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
  //   }
  // };
  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    // Change confirmation text based on edit mode
    const result = await Swal.fire({
      title: isEditMode
        ? "Update the changes?"
        : "Are you sure you want to create this task?",
      showCancelButton: true,
      confirmButtonText: isEditMode ? "Update" : "Submit",
    });

    if (!result.isConfirmed) return;

    try {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear();
      const updatedDate = `${day}-${month}-${year}`;
      let hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      const updatedTime = `${hours}:${minutes} ${ampm}`;

      const taskPayload = {
        ...taskData,
        assignedBy: { staffName, id: Id },
        updatedDate,
        updatedTime,
        assignedTo: selectedNames,
        approvePerson: approvePersons,
      };

      // Required validation
      const requiredFields = [
        "taskName",
        "assignDateTime",
        "deadline",
        // "description",
      ];
      const emptyFields = requiredFields.filter(
        (field) =>
          !taskPayload[field] ||
          (Array.isArray(taskPayload[field]) && taskPayload[field].length === 0)
      );

      if (emptyFields.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Incomplete Data",
          text: `Please fill all the fields.`,
        });
        return;
      }

      // === Save to backend ===
      let savedId = "";

      if (isEditMode) {
        // Update logic
        await axios.post(apiUrl + "update-assign-task", taskPayload, {
          headers: { "Content-Type": "application/json" },
        });
        savedId = taskPayload._id;
      } else {
        // Create logic
        const response = await axios.post(
          apiUrl + "add-assign-task",
          taskPayload,
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        savedId = response.data?.data?._id;

        // ▼▼▼ SEND NOTIFICATIONS ONLY FOR NEW TASKS ▼▼▼
        try {
          // Notify assigned persons
          await Promise.all(
            selectedNames.map(async (staff) => {
              const title = `New Task: ${taskData.taskName}`;
              const body = `You've been assigned a new task by ${staffName}`;

              await sendNotification(title, body, staff._id, staff.staffName);
            })
          );

          // Notify approvers
          await Promise.all(
            approvePersons.map(async (staff) => {
              const title = `Approval Required: ${taskData.taskName}`;
              const body =
                `You need to approve a task assigned by ${staffName}` +
                `Assigned to: ${selectedNames
                  .map((s) => s.staffName)
                  .join(", ")}`;

              await sendNotification(title, body, staff._id, staff.staffName);
            })
          );
        } catch (notificationError) {
          console.warn("Notifications failed:", notificationError);
          // Optionally show a warning (but don't fail the whole operation)
          Swal.fire({
            icon: "info",
            title: "Task created",
            text: "Task was created but some notifications may not have been delivered",
            timer: 2000,
            showConfirmButton: false,
          });
        }
        // ▲▲▲ END OF NOTIFICATION CODE ▲▲▲
      }

      // === Add Message (history) ===
      const formData = new FormData();
      formData.append("pageRefId", savedId);
      formData.append("page", "Task");
      formData.append("colorCode", "#fbdc6e");
      formData.append("description", taskData.description||"No Description");
      formData.append("staffPic", "");
      if (selectedFile) {
        formData.append("image", selectedFile);
      }
      formData.append("updatesHistory[staff][name]", staffName);
      formData.append("updatesHistory[staff][id]", Id);
      formData.append("updatesHistory[status]", "Open");

      await axios.post(apiUrl + "add-message", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // ✅ Fetch messages after update
      const msgRes = await axios.get(`${apiUrl}messages/${savedId}`);
      setMessageData(msgRes.data.data);
      setShowMessageBox(true);

      Swal.fire(
        "Success!",
        isEditMode ? "Task Updated" : "Task Created",
        "success"
      );
      setIsEditable(false);
      setIsEditMode(false);
      setIsSubmitted(true);
    } catch (error) {
      console.error("Submit error:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong!",
        "error"
      );
    }
  };

  const getFutureDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 1); // add 1 minute to current time
    return now.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:MM'
  };

  return (
    <>
      <Topbar />
      <Container className="mt-1">
        <Row className="ct-mainhead">
          <Col>
            <h3>My Task</h3>
          </Col>

          <Col className="text-end">
            <button
              className="bluetask-btn px-4 text-white"
              value="submit"
              type="submit"
              // onClick={gototaskPage}
              onClick={handleSubmitAssignTask}
            >
              Submit
            </button>
          </Col>
        </Row>
        <Row className="task-create-container">
          <div className="task-shadow">
            <form>
              <h6 className="create-task-head">Create Task</h6>
              <div className="create-task-head-1">
                <Row className="g-5">
                  <Col sm={12} md={6}>
                    <Row>
                      <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Task Name
                        </lable>
                        <br />
                        <input
                          sm={12}
                          type="text"
                          onChange={(e) =>
                            handleInputChange("taskName", e.target.value)
                          }
                          name="taskName"
                          className="form-input"
                          placeholder="Enter Task Name"
                          required
                          style={{ textTransform: "capitalize" }}
                        />
                      </Col>

                     <Col sm={12} md={6} className="text-start">
  <label className="rowdown">Assign Date/Time</label>
  <br />
  <input
    type="datetime-local"
    value={taskData.assignDateTime}
    required
      min={getFutureDateTime()} // optional: restrict past values

    className="form-input"
    onChange={(e) => handleInputChange('assignDateTime', e.target.value)}
  />
</Col>


                    </Row>
                    <Row>
                      <Col xs={12} md={6} className="text-start">
                        <label>Task Assign To</label>
                        <br />
                        <div
                          ref={dropdownRef}
                          style={{ position: "relative", width: "85%" }}
                        >
                          <div
                            onClick={toggleDropdown}
                            style={{
                              padding: "10px",
                              border: "2px solid #a7a7a7",
                              borderRadius: "4px",
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginTop: "10px",
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {displayText}
                            </span>
                            <span>{isOpen ? "▲" : "▼"}</span>
                          </div>

                          {isOpen && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                marginTop: "5px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                zIndex: 1000,
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              {/* 🔍 Search Input */}
                              <input
                                type="text"
                                placeholder="Search staff..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{
                                  width: "95%",
                                  margin: "10px auto",
                                  display: "block",
                                  padding: "8px",
                                  borderRadius: "4px",
                                  border: "1px solid #ccc",
                                }}
                              />

                              {/* Filtered Staff List */}
                              {staffData
                                .filter((staff) =>
                                  staff.staffName
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                ).length === 0 ? (
                                <div
                                  style={{
                                    padding: "10px",
                                    color: "#888",
                                    textAlign: "center",
                                  }}
                                >
                                  No Staffs found
                                </div>
                              ) : (
                                staffData
                                  .filter((staff) =>
                                    staff.staffName
                                      .toLowerCase()
                                      .includes(searchText.toLowerCase())
                                  )
                                  .map((staff) => (
                                    <label
                                      key={staff._id}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px",
                                        cursor: "pointer",
                                        borderBottom: "1px solid #eee",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={selectedNames.some(
                                          (item) => item._id === staff._id
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(staff)
                                        }
                                        style={{ marginRight: "10px" }}
                                      />
                                      {staff.staffName} {staff.designation ? `(${staff.designation})` : ""}
                                    </label>
                                  ))
                              )}
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col xs={12} md={6} className="text-start">
                        <label>Approve Person</label>
                        <br />
                        <div
                          ref={approveDropdownRef}
                          style={{
                            position: "relative",
                            width: "85%",
                            marginTop: "15px",
                          }}
                        >
                          <div
                            onClick={toggleApproveDropdown}
                            style={{
                              padding: "10px",
                              border: "2px solid #a7a7a7",
                              borderRadius: "4px",
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginTop: "-5px",
                            }}
                          >
                            <span
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {approvePersonText}
                            </span>
                            <span>{isApproveOpen ? "▲" : "▼"}</span>
                          </div>

                          {isApproveOpen && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                                right: 0,
                                marginTop: "5px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                zIndex: 1000,
                                maxHeight: "250px",
                                overflowY: "auto",
                              }}
                            >
                              {/* 🔍 Search Input */}
                              <input
                                type="text"
                                placeholder="Search staff..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                  width: "100%",
                                  padding: "8px 10px",
                                  borderBottom: "1px solid #ccc",
                                  boxSizing: "border-box",
                                  outline: "none",
                                  border: "none",
                                }}
                              />

                              {/* 🧑‍💼 Filtered Staff List */}
                              {filteredNames.length === 0 ? (
                                <div
                                  style={{
                                    padding: "10px",
                                    color: "#888",
                                    textAlign: "center",
                                  }}
                                >
                                  No staff found
                                </div>
                              ) : (
                                filteredNames.map((staff) => (
                                  <label
                                    key={staff._id}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      padding: "10px",
                                      cursor: "pointer",
                                      borderBottom: "1px solid #eee",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      required
                                      checked={approvePersons.some(
                                        (item) => item._id === staff._id
                                      )}
                                      onChange={() =>
                                        handleApproveCheckboxChange(staff)
                                      }
                                      style={{ marginRight: "10px" }}
                                    />
                                    {staff.staffName || "(No Name)"}
                                  </label>
                                ))
                              )}
                            </div>
                          )}
                        </div>
                      </Col>

                      {/* <Col xs={12} md={12} className="text-start mt-4">
                        <lable>Description</lable>
                        <br />
                        <textarea
                          type="text"
                          onChange={(e) => handleInputChange('description', e.target.value)}
                          style={{
                            textTransform: "capitalize",
                            resize: "none",

                          }}
                          className="form-input inputfield-assign "
                          placeholder="Enter Notes "
                          required
                        />

                      </Col> */}
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Deadline Date/Time
                        </lable>
                        <br />

                                                  <input
  type="datetime-local"
  value={taskData.deadline || ""}
  min={getFutureDateTime()} // optional: restrict past values
  onChange={(e) =>
    handleInputChange("deadline", e.target.value)
  }
  className="form-input overlay2"
/>

                      </Col>

                      <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Task Priority</lable>
                        <br />
                        <select
                          required
                          onChange={(e) =>
                            handleInputChange("taskPriority", e.target.value)
                          }
                          class="dropbtn form-input-select overlay2"
                        >
                          <option value="Low">Low</option>
                          <option value="High">High</option>
                          <option value="Immediate">Immediate</option>
                        </select>
                      </Col>

                      {/* <Col xs={12} md={6} className="text-start">
                        <lable> Deadline Time</lable>
                        <br />
                        <input
                          required
                          type="time"
                          onChange={(e) => handleInputChange('time', e.target.value)}
                          className="form-input overlay2"
                          placeholder=""
                        />
                      </Col> */}
                    </Row>

                    <Row>
                      {/* <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Task Type
                        </lable>
                        <br />
                        <select
                          onChange={(e) => handleInputChange('taskType', e.target.value)}
                          class="dropbtn form-input-select overlay2"
                          required

                        >
                          <option


                            value="Once"
                          >
                            Once
                          </option>
                          <option value="Daily">
                            Daily
                          </option>
                          <option value="weekly">
                            Weekly
                          </option>
                          <option value="Monthy">
                            Monthly
                          </option>
                          <option value="Custom">
                            Custom
                          </option>
                        </select>
                      </Col> */}

                      <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Task Status</lable>
                        <br />

                        <input
                          style={{
                            backgroundColor: "#fbdc6e",
                            color: "rgb(94, 94, 14)",
                          }}
                          type="button"
                          onClick={() => setIsOpenConverted(true)}
                          className="form-input converted-form"
                          name="installleadStatus"
                          value="Open"
                        />

                        {isOpenConverted && (
                          <div className="overlay1-open">
                            <div className="modal1-open">
                              <Container>
                                <button
                                  type="button"
                                  className="close-btn1"
                                  onClick={() => setIsOpenConverted(false)}
                                >
                                  <span style={{ fontSize: "20px" }}>
                                    &times;
                                  </span>
                                </button>

                                <div className="open-button">
                                  <h5>Open</h5>
                                </div>

                                <textarea
                                  type="text"
                                  onChange={(e) =>
                                    handleInputChange(
                                      "description",
                                      e.target.value
                                    )
                                  }
                                  style={{
                                    textTransform: "capitalize",
                                    resize: "none",
                                  }}
                                  className="open-textbox"
                                  placeholder="Enter Notes "
                                  required
                                />

                                <div className="upload-section">
                                  <label className="upload-btn">
                                    <FiUpload className="upload-icon" />
                                    Upload Image
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={handleFileChange}
                                      hidden
                                    />
                                  </label>
                                  {selectedFile && (
                                    <p className="file-name">
                                      {selectedFile.name}
                                    </p>
                                  )}
                                </div>

                                <Row>
                                  <Col className="uploadbtn-install">
                                    <button
                                      type="button"
                                      className="blue-btn"
                                      onClick={() => setIsOpenConverted(false)}
                                    >
                                      Upload
                                    </button>
                                  </Col>
                                </Row>
                              </Container>
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>

                    {/* <Col xs={12} md={6} className="text-start mt-3">
                        <lable>Task Status  </lable>
                        <br />
                     <input style={{ backgroundColor: "#fbdc6e", color: "rgb(94, 94, 14)" }}
                      type="button"
                      onClick={() => setIsOpenConverted(true)}
                      className="form-input converted-form"
                      name="installleadStatus"
                      value="Open"

                    />

                      </Col> */}
                  </Col>
                </Row>
              </div>
            </form>
          </div>
        </Row>

        {showMessageBox && (
          <Row className="container ms-3  me-5">
            <Col md={6} sm={12}>
              <div>
                {messageData &&
                  messageData.map((msg) => (
                    <MessageBox key={msg._id} message={msg} />
                  ))}{" "}
              </div>
            </Col>
            <Col md={6} sm={12} className="">
              {/* Updates History Section */}
              <div className="compact-updates-history">
                <div className="compact-updates-header"> Updates History </div>
                {messageData &&
                  messageData.map((data, index) => (
                    <div className="compact-update text-center" key={index}>
                      <div className="compact-update-date text-center">
                        {new Date(data.updatesHistory.date).toLocaleDateString(
                          "en-GB"
                        ) +
                          " - " +
                          new Date(data.updatesHistory.date)
                            .toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace(":", ".")}
                      </div>

                      <div className="compact-update-user text-center">
                        {" "}
                        {data.updatesHistory.staff?.name}{" "}
                      </div>
                      <div
                        className={"compact-update-status text-center "}
                        style={{
                          color: data.colorCode ? data.colorCode : "#000000",
                        }}
                      >
                        {data.updatesHistory.status}
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
}
